export const NOTIFICATION_CATEGORY_MAP = {
  follow: 'likes', like: 'likes', reaction: 'likes', comment_like: 'likes',
  comment: 'comments',
  share: 'messages',
  eventInvite: 'events', event_join: 'events',
  group_invite: 'groups', group_join_request: 'groups',
};

export const DEFAULT_NOTIFICATION_PREFS = { likes: true, comments: true, messages: true, events: true, groups: true };

// Set per environment in .env.staging / .env.production. No fallback: a missing
// key turns address suggestions off instead of borrowing another project's key.
export const GOOGLE_MAPS_API_KEY = process.env.REACT_APP_GOOGLE_MAPS_API_KEY || '';

export const GAME_TYPES = [
  { id: 'stroke', name: 'Stroke', emoji: '📊', desc: 'Traditional stroke play — lowest total wins' },
  { id: 'nassau', name: 'Nassau', emoji: '🏌️', desc: 'Front 9, Back 9, Overall match play' },
  { id: 'scramble', name: 'Scramble', emoji: '🤝', desc: 'Team picks best shot each stroke, all play from there' },
  { id: 'stableford', name: 'Stableford', emoji: '⭐', desc: 'Points-based scoring — higher points win' },
  { id: 'matchPlay', name: 'Match Play', emoji: '⚔️', desc: 'Hole-by-hole competition — win the most holes' },
  { id: 'skins', name: 'Skins', emoji: '🏆', desc: 'Win hole outright = win the skin' },
  { id: 'bestBall', name: 'Best Ball', emoji: '🎯', desc: 'Team game — best score per hole from each team' },
  { id: 'vegas', name: 'Vegas', emoji: '🎰', desc: '2v2 — combine scores as two-digit number' },
  { id: 'wolf', name: 'Wolf', emoji: '🐺', desc: 'Rotating wolf picks partner or goes solo' },
  { id: 'alternateShot', name: 'Alternate Shot', emoji: '🔄', desc: '2-person teams alternate hitting' },
  { id: 'press', name: 'Press', emoji: '📈', desc: 'Side bet when down by 2+' },
  { id: 'banker', name: 'Banker', emoji: '🏦', desc: 'Points-based — closest to pin earns from others' },
];

export const TEAM_GAMES = ['bestBall', 'vegas', 'alternateShot', 'scramble'];
